// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.ledger-label[data-v-125608f8] {\n\tmargin-bottom: 8px;\n\tfont-weight: 500;\n}\n.w100[data-v-125608f8], .w100[data-v-125608f8] .w-input, .w100[data-v-125608f8] .w-input-autocomplete {\n\twidth: 100%;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
